import {
  GamoraConstructorType,
  GamoraFoundationNode,
  GamoraFoundationNodeArgs,
  GamoraMaybe,
} from '@ver.id/libs.internal.gamora';
import { HoruzQueueDataNode, HoruzQueueDataNodeArgs } from './data.js';
import { IHoruz } from '../horuz.js';

/**
 * Children map
 * @public
 */
export interface HoruzQueueNodeChildrenMap<TRoot extends IHoruz> {
  data: GamoraConstructorType<
    HoruzQueueDataNode<TRoot>,
    HoruzQueueDataNodeArgs<TRoot>
  >;
}

/**
 * Args
 * @public
 */
export interface HoruzQueueNodeArgs<
  TRoot extends IHoruz,
> extends GamoraFoundationNodeArgs<HoruzQueueNodeChildrenMap<TRoot>> {
  data?: GamoraMaybe<HoruzQueueDataNodeArgs<TRoot>>;
}

/**
 * HoruzQueueNode
 * @public
 */
export class HoruzQueueNode<TRoot extends IHoruz> extends GamoraFoundationNode<
  HoruzQueueNodeChildrenMap<TRoot>,
  TRoot
> {
  constructor(args: HoruzQueueNodeArgs<TRoot>) {
    super({
      ...args,
      childMap: {
        data: [HoruzQueueDataNode, args.data ?? {}],
      },
    });
  }
}
